module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "error-wrap"
  }, [_c('div', {
    staticClass: "wrapper"
  }, [(_vm.typeFlag === 0) ? _c('div', {
    staticClass: "img-wrap"
  }, [_c('img', {
    attrs: {
      "src": require("./../../assets/img/timeout.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "info"
  }, [_vm._v("登录超时，请重新登录")])]) : _vm._e(), _vm._v(" "), (_vm.typeFlag === 1) ? _c('div', {
    staticClass: "img-wrap"
  }, [_c('img', {
    attrs: {
      "src": require("./../../assets/img/404.png"),
      "alt": ""
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "operate-wrap"
  }, [_c('p', [_vm._v(_vm._s(_vm.time) + "s后"), _c('a', {
    attrs: {
      "href": ""
    }
  }, [_vm._v("跳转")]), _vm._v("到首页")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-74280fe4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/common/error.vue
// module id = 1018
// module chunks = 1